import {
  AUDIT_ACTION_LABELS,
  summarizeAuditChange,
} from '@/services/audit/labels';
import { useEntityAuditTrail } from '@/shared/hooks/useEntityAuditTrail';
import { useAuth } from '@/shared/hooks/useAuth';
import type { AuditEntityType } from '@/types/audit';

type EntityAuditTrailProps = {
  entityType: AuditEntityType;
  entityId: string | undefined;
  title?: string;
};

function formatWhen(date: Date): string {
  return date.toLocaleString('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export function EntityAuditTrail({
  entityType,
  entityId,
  title = 'Historial de cambios',
}: EntityAuditTrailProps) {
  const { hasPermission } = useAuth();
  const canRead = hasPermission('audit.read');
  const { logs, loading, error } = useEntityAuditTrail(entityType, entityId);

  if (!canRead || !entityId) return null;

  return (
    <section className="inventory-panel audit-trail">
      <h2>{title}</h2>
      {loading ? <p className="auth-muted">Cargando historial…</p> : null}
      {error ? <p className="auth-error">{error}</p> : null}
      {!loading && !error && logs.length === 0 ? (
        <p className="auth-muted">Sin registros de auditoría para esta entidad.</p>
      ) : null}
      {logs.length > 0 ? (
        <table className="users-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Acción</th>
              <th>Detalle</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td>{formatWhen(log.createdAt)}</td>
                <td>
                  {log.actorEmail ?? log.actorUid}
                  {log.actorRole ? (
                    <span className="auth-muted"> ({log.actorRole})</span>
                  ) : null}
                </td>
                <td>{AUDIT_ACTION_LABELS[log.action]}</td>
                <td>{summarizeAuditChange(log)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </section>
  );
}
